import { Box, FormControl, MenuItem, Select } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoading } from "../../../providers/loadingProvider";
import { reportingAsSelector, setAs } from "../../../store/applicantsSlice";
import {
  setColleagues,
  proposalSelector,
  pisColleaguesSelector,
} from "../../../store/proposalSlice";
import { userSelector } from "../../../store/userSlice";
import { ApplicantType } from "../../advisors/Constants";
import CustomBox from "../../public/Components/CustomBox";
import service from "../helpers/GifService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(1),
    minWidth: 300,
  },
}));
export default function ApplicantSelector(props) {
  const { onChange, showAll, ...rest } = props;
  const applicants = useSelector(pisColleaguesSelector);
  const user = useSelector(userSelector);
  const as = useSelector(reportingAsSelector);
  const proposal = useSelector(proposalSelector);
  const loading = useLoading();

  const [selectedApplicant, setSelectedApplicant] = useState(
    showAll ? "all" : as || user?.emails[0] || ""
  );

  const dispatch = useDispatch();
  const classes = useStyles();

  const getApplicants = useCallback(async () => {
    if (!!applicants && applicants.length > 0) return;
    if (!proposal?.id || !user?.emails) {
      return;
    }
    
    const lid = loading.addLoading("loading apppicants");
    const retrivedApplicants = await service.getColleagues({
      proposalId: proposal?.id,
    });

    dispatch(setColleagues(retrivedApplicants));
    const pis = retrivedApplicants.filter((a) => a.pici === ApplicantType.PI);
    debugger;
    const emails = pis.map((a) => a.email);
    if (emails.includes(user.emails[0]))
      setSelectedApplicant(showAll ? "all" : user.emails[0]);
    setSelectedApplicant(showAll ? "all" : pis[0].email);
    loading.removeLoading(lid);
  }, [applicants, proposal?.id, user.emails, loading, dispatch, showAll]);

  useEffect(() => {
    if (!!applicants?.length) return;
    getApplicants();
  }, [applicants, as, dispatch, getApplicants, user?.emails]);

  useEffect(() => {
    if (selectedApplicant === "all") return;
    if (user?.emails[0] === selectedApplicant) {
      if (as !== null) dispatch(setAs(null));
    } else if (as !== selectedApplicant) dispatch(setAs(selectedApplicant));
  }, [applicants, as, dispatch, onChange, selectedApplicant, user?.emails]);

  const applicantChanged = (e) => {
    if (typeof onChange === "function") {
      const applicant = applicants.find((a) => a.email === e.target.value);
      onChange(applicant || { id: e.target.value });
    }
    setSelectedApplicant(e.target.value);
  };
  const Applicants = forwardRef((props, ref) => (
    <FormControl
      {...props}
      ref={ref}
      className={classes.formControl}
      size="small"
    >
      <Select
        value={selectedApplicant}
        onChange={applicantChanged}
        id="applicant"
      >
        {showAll && <MenuItem value="all">All Applicants</MenuItem>}
        {applicants.map((a) => (
          <MenuItem key={a.id} value={a.email}>
            {a.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ));
  const Applicant = forwardRef((props, ref) => (
    <CustomBox
      fw={600}
      fs={16}
      {...props}
      ref={ref}
      className={classes.formControl}
    >
      {applicants[0]?.name}
    </CustomBox>
  ));
  return (
    <Box {...rest}>
      {applicants.length < 2 ? <Applicant /> : <Applicants />}
    </Box>
  );
}
